import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPageView } from "../lib/analytics";

// Fires a de-duplicated Meta Pixel PageView on each meaningful route change.
// Placed inside <BrowserRouter> so useLocation is available.
export default function MetaRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackMetaPageView(location.pathname);
  }, [location.pathname]);
  return null;
}
